/**
 * Validate an email address
 * - Formats if valid
 */

/**  Environment  */
import environmentVariables from '../util/environmentVariables';
environmentVariables();

/**  Globals  */
const EMAIL_PATTERN = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

/**  Interfaces  */
interface IToolboxValidateEmailResponse {
    valid: boolean;
    email?: string;
}

/**  Method  */
export default function validateEmail(email: string): IToolboxValidateEmailResponse {
    if (typeof email !== 'string') {
        return {
            valid: false,
        };
    }

    const email_lowercase = email.toLowerCase().trim();
    const valid = EMAIL_PATTERN.test(email_lowercase);

    return {
        valid,
        email: email_lowercase,
    };
}
